import useFactories from "hooks/useFactories";
import Errors from "../base/Errors";
import { Select } from "../base/Form";
import { InlineSpinner } from "../base/Spinner";

function FactorySelector({
  value,
  onChange,
  filterSuppliers = null,
  allowedNull = true,
  ...rest
}) {
  const { loading, error, allFactories } = useFactories();

  if (loading)
    return (
      <div className="flex relative">
        <InlineSpinner size={18} text={null} />
      </div>
    );
  if (error) return <Errors error={error} />;

  // Filter suppliers if filterSuppliers is provided
  const factoriesToUse =
    filterSuppliers && filterSuppliers.length > 0
      ? allFactories.filter((f) => filterSuppliers.some((fs) => fs.id === f.id))
      : allFactories;

  const suppliers = factoriesToUse.map((i) => {
    const companies = [...i.odooCompanies].sort((a, b) => a.localeCompare(b));
    return {
      ...i,
      companyNames: companies.length > 0 ? companies.join(",") : "NO COMPANY",
    };
  });

  let companies = [];
  suppliers.forEach((i) => {
    if (!companies.includes(i.companyNames)) companies.push(i.companyNames);
  });

  return (
    <Select
      value={value || "0"}
      onChange={(e) => {
        const selectedId = e.target.value;
        onChange(selectedId === "0" ? null : selectedId);
      }}
      {...rest}
    >
      <option value="0" disabled={!allowedNull}>
        -- Select a Supplier --
      </option>
      {companies.map((company) => (
        <optgroup label={company} key={company}>
          {suppliers
            .filter((factory) => factory.companyNames === company)
            .map((factory) => (
              <option key={factory.id} value={factory.id}>
                {factory.name}
                {factory.odooCompanies.length > 0 &&
                  ` [${factory.odooCompanies.join(",")}] `}
              </option>
            ))}
        </optgroup>
      ))}
    </Select>
  );
}

export default FactorySelector;
